import type { StimulusContent } from "./content";
import type {
	OriginalStimulusTypes,
	SkillTypes,
	SourceMetadataItemTypes,
} from "./types";

export type UnifiedCitation = {
	title: string;
	pageContent: string;
	sourceId?: number;
	id?: number;
	url?: string;
	page?: number;
	thumbnailUri?: string;
};

export type BaseItemMetadata = {
	topics: string[];
	title: string;
	skill?: SkillTypes;
	countryCode?: string;
	citations?: UnifiedCitation[];
	section?: string;
};

export interface ItemMetadata extends BaseItemMetadata {
	type: SourceMetadataItemTypes;
}

export interface StimulusMetadata extends BaseItemMetadata {
	type: OriginalStimulusTypes;
}

export type Stimulus = {
	id: number;
	content: StimulusContent;
	metadata: StimulusMetadata;
};

export type WebCitation = {
	citation: {
		id: number;
		title: string;
		source: string;
		url: string;
		pageContent: string;
	};
};

export type VectorDocument = {
	metadata: {
		sourceId: number;
		title: string;
		chapter?: string;
		subChapter?: string;
		pageContent: string;
		cfi?: string;
		id: number;
		loc: {
			lines: {
				to: number;
				from: number;
			};
		};
		page: number;
		items: unknown[];
		links: unknown[];
		width: number;
		author: string;
		charts: unknown[];
		height: number;
		images: unknown[];
		status: string;
		creator: string;
		subject: string;
		keywords: string;
		numPages: number;
		producer: string;
		description: string;
		parsingMode: string;
		creationDate: string;
		noTextContent: boolean;
		structuredData: unknown;
		sourceVersionId: number;
		triggeredAutoMode: boolean;
		noStructuredContent: boolean;
		thumbnailUri?: string;
	};
};
